$(document).ready(function() {
    var what = '.bg-forgot-password-form';
    var url = bg_consts.API.RESET_PASSWORD;

    var messages = {
        'mail': {
            'required': bg_globals.i18n.form.errors.missing_field
        }
    };

    /* the rules have "depends" conditions because the field is used for
       email and phone validation */
    var rules = {
        'mail': {
            'required': true,
            'email': {
                depends: function(element) {
                    return ($(element).val().match(/^(\+)|(\+?\d)/) === null);
                }
            }
            /*'phone_au_multiformat': {
                depends: function(element) {
                    return ($(element).val().match(/^(\+)|(\+?\d)/) !== null);
                }
            }*/
        }
    };

    var alertBox = '.byg_alertError';

    var successFnc = function(paraMs) {
        if (paraMs.apiUrl === bg_consts.API.RESET_PASSWORD_BY_PHONE) {
            /*
            var target = bg_globals.base_url + "forgot-password-phone-confirm";
            var toOtpForm = document.createElement("form");
            var hidPhone = document.createElement("input");
            var custPhone = $(paraMs.what).find("[name=phone]").val();
            var csrfToken = document.createElement("input");

            hidPhone.setAttribute("type", "hidden");
            hidPhone.setAttribute("value", custPhone);
            hidPhone.setAttribute("name", "phone");

            csrfToken.setAttribute("name", "_csrf");
            csrfToken.setAttribute("type", "hidden");
            csrfToken.value = bg_globals.csrf_token_value;

            toOtpForm.setAttribute("action", target);
            toOtpForm.setAttribute("method", "POST");
            toOtpForm.setAttribute("id", "toOtpForm");
            toOtpForm.appendChild(hidPhone);
            toOtpForm.appendChild(csrfToken);

            $("body").append(toOtpForm);
            toOtpForm.submit();
            */
        } else {
            bg_utils.hide(what);
            bg_utils.show('.byg_alertSuccess');
        }
    };

    bg_validator.validateV2(what, url, messages, rules, alertBox, successFnc, {
        beforeSend: function(form, paraMs) {
            var mailField = $(form).find("[name=mail]");
            var mailFieldVal = mailField.val();
            if (mailField.val().indexOf("@") == -1) {
                /*/not an email address, so it must be phone */
                //paraMs.apiUrl = bg_consts.API.RESET_PASSWORD_BY_PHONE;
                //var normalizedPhone = mailFieldVal.replace(/^((\+610)|(\+61)|0)/, '');
                //$(form).find("[name=phone]").val('+61' + normalizedPhone);
            } else {
                paraMs.apiUrl = bg_consts.API.RESET_PASSWORD;
            }
        }
    });

    $('[data-toggle=popover]').popover({
        'html': true
    });


    // Resend reset password email.
    $('.resend_mail__forgot_password').click(function() {
        var mailField    = $(what).find("[name=mail]");
        var mailFieldVal = mailField.val();
        $.ajax({
            'url': bg_consts.API.RESET_PASSWORD,
            'type': 'POST',
            'dataType': 'json', // expected type from server
            'data': {
                'mail': mailFieldVal
            },
            'error': function(xhr, ajaxOptions, thrownError) {
                bg_utils.show('.byg_mailResendError');
            }
        }).done(
          //function(){alert('done');}
        );
    });

});
